<template>
  <div class="ShareButton">

    <button-component class="ShareButton-button"
      :label="label"
      @click.native="openModal"
      icon="share" />

    <div class="ShareButton-content">

      <slot></slot>

    </div>

  </div>
</template>

<script>
export default {
  name: 'ShareButton',

  props: {
    label: {
      type: String,
      default: 'Share'
    }
  },

  computed: {
    window () { return this.$store.state.window }
  },

  methods: {
    /**
     * Open modal
     * - Only if window height is >= 420px
     */
    openModal () {
      if (this.window.height >= 420) return
      this.$store.dispatch('share/openModal')
    }
  }
}
</script>

<style>
@import 'properties';

.ShareButton {
  position: relative;
  display: flex;
  cursor: pointer;
}

.ShareButton-button {
  position: relative;
  z-index: 1;
  height: 30px;
  border-color: var(--c-grey-lt-075);
  cursor: pointer;
}

.ShareButton:hover .ShareButton-button {
  border-color: var(--c-blue);
}

.ShareButton:hover .Share-button {
  border-color: var(--c-blue);
}

.ShareButton-button .Button-label {
  font-size: 13px;
  color: var(--c-grey-lt-075);
}

.ShareButton:hover .Button-label {
  color: var(--c-white);
}

.ShareButton-button > * + * {
  margin-left: var(--unit-025);
}

.ShareButton .Icon {
  position: relative;
  top: -1px;
  width: 11px !important;
  height: 16px !important;
}

.ShareButton-button svg {
  fill: var(--c-grey-lt-075) !important;
}

.ShareButton:hover .ShareButton-button svg {
  fill: var(--c-white) !important;
}

.ShareButton-content {
  position: absolute;
  z-index: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: none;

  @media (min-width: 600px) {
    top: 0;
    bottom: auto;
  }
}

.ShareButton:hover .ShareButton-content {
  /* display: block; */

  @media (min-height: 420px) {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// ShareButton.vue?142e9400